<template>
  <div class="layout-product-page" @click="offersProduct()">
    <!-- mobile view -->
    <div v-if="isMobile">
      <slot name="gallery"></slot>
      <div class="px-gap">
        <div class="flex items-center justify-between mb-2">
          <slot name="info"></slot>
          <slot name="cart-compare-buttons"
                :checkCompare="checkCompare"
                :activeCompare="activeCompare"
                :checkFavorite="checkFavorite"
                :activeFavorite="activeFavorite"
          ></slot>
        </div>
        <slot name="details"
          :getNameOffer="getNameOffer"
        ></slot>
        <slot name="controls"
              :setPododeyalniki="setPododeyalniki"
              :currentSizePododeyalnika="currentSizePododeyalnika"
              :currentPododeyalnik="currentPododeyalnik"
              :arSizesPododeyalnika="arSizesPododeyalnika"
              :loadSizePododeyalnik="loadSizePododeyalnik"
              :arMaterialPododeyalnika="arMaterialPododeyalnika"
              :currentMaterialPododeyalnika="currentMaterialPododeyalnika"
              :setProstyni="setProstyni"
              :currentProstyn="currentProstyn"
              :currentSizeProstyn="currentSizeProstyn"
              :arSizeProstyn="arSizeProstyn"
              :loadSizeProstyn="loadSizeProstyn"
              :arMaterialProstyn="arMaterialProstyn"
              :currentMaterialProstyn="currentMaterialProstyn"
              :setNavolchki="setNavolchki"
              :currentSizeNavolchki="currentSizeNavolchki"
              :currentNavolchki="currentNavolchki"
              :arSizeNavolchki="arSizeNavolchki"
              :loadSizeNavolchki="loadSizeNavolchki"
              :arMaterialNavolchki="arMaterialNavolchki"
              :currentMaterialNavolchki="currentMaterialNavolchki"
              :setValiki="setValiki"
              :currentSizeValiki="currentSizeValiki"
              :currentValiki="currentValiki"
              :arSizeValiki="arSizeValiki"
              :loadSizeValiki="loadSizeValiki"
              :arMaterialValiki="arMaterialValiki"
              :currentMaterialValiki="currentMaterialValiki"
              :setProstynUniversal="setProstynUniversal"
              :currentSizeProstynUniversal="currentSizeProstynUniversal"
              :currentProstynUniversal="currentProstynUniversal"
              :arSizeProstynUniversal="arSizeProstynUniversal"
              :loadSizeProstynUniversal="loadSizeProstynUniversal"
              :arMaterialProstynUniversal="arMaterialProstynUniversal"
              :currentMaterialProstynUniversal="currentMaterialProstynUniversal"
              :offerActual="offerActual"
              :sizeInfo="sizeInfo"
              :arSize="arSize"
              :currentMaterials="currentMaterials"
              :categories="categories"
              :fabrics="fabrics"
              :fabricsSections="fabricsSections"
              :offerIdNozhkiCurrent="offerIdNozhkiCurrent"
              :offerIdOsnovaniyaCurrent="offerIdOsnovaniyaCurrent"
              :offerIdIzgolovyaCurrent="offerIdIzgolovyaCurrent"
              :formatPrice="formatPrice"
        ></slot>
      </div>
      <div class="mt-3">
        <slot name="description"></slot>
      </div>
      <slot name="scheme"
            :dlina="dlina"
            :shirina="shirina"
            :visota="visota"
            :sizeInfo="sizeInfo"
            :arSize="arSize"
            :request3Df="request3Df"
            :currentSize="currentSize"
      ></slot>
      <slot name="objectpdf"></slot>
      <div class="px-gap">
        <slot name="chart"></slot>
      </div>
      <div class="pb-10 overflow-x-scroll px-gap">
        <div class="grid auto-cols-[80vw] grid-flow-col gap-x-3">
          <slot name="features"></slot>
          <div class="w-gap"></div>
        </div>
      </div>
      <div class="px-gap">
        <slot name="tabs"></slot>
        <slot name="layers"></slot>
        <slot name="adds"></slot>
        <slot name="cards"
              :offerActual="offerActual"
              :deliveryPopup="deliveryPopup"
              :checkBoxberry="checkBoxberry"
              :openBoxberry="openBoxberry"
              :locationPickup="locationPickup"
              :quantity="quantity"
        ></slot>
        <slot name="services"></slot>
        <slot name="help"></slot>
        <slot name="testimonials"></slot>
        <div class="mt-10">
          <slot name="problem"
                :view_message="view_message"
                :setShowRoomSign="setShowRoomSign"
                :setTestDriveHome="setTestDriveHome"
          ></slot>
        </div>
      </div>
      <slot name="alts"></slot>
      <!-- <slot name="other"></slot> -->
      <slot name="cached"></slot>
    </div>
    <!-- desktop view -->

    <div v-else class="pt-4">
      <div class="container grid lg:grid-cols-[2fr,1.5fr] xl:grid-cols-[2fr,1fr] gap-x-[3vw] px-gap">
        <div class="flex items-center justify-between col-span-2 mb-3">
          <slot name="breadcrumbs"></slot>
          <slot name="cart-compare-buttons"
                :checkCompare="checkCompare"
                :activeCompare="activeCompare"
                :checkFavorite="checkFavorite"
                :activeFavorite="activeFavorite"
          ></slot>
        </div>
        <div>
          <slot name="gallery"></slot>
          <slot name="description"></slot>
          <slot name="objectpdf"></slot>
          <slot name="chart"></slot>
          <slot name="features"></slot>
          <slot name="scheme"
                :dlina="dlina"
                :shirina="shirina"
                :visota="visota"
                :sizeInfo="sizeInfo"
                :arSize="arSize"
                :request3Df="request3Df"
                :currentSize="currentSize"
          ></slot>
        </div>
        <div>
          <div class="mb-3">
            <slot name="info"></slot>
          </div>
          <slot name="details"
                :getNameOffer="getNameOffer"
          ></slot>
          <slot name="controls"
                :setPododeyalniki="setPododeyalniki"
                :currentSizePododeyalnika="currentSizePododeyalnika"
                :currentPododeyalnik="currentPododeyalnik"
                :arSizesPododeyalnika="arSizesPododeyalnika"
                :loadSizePododeyalnik="loadSizePododeyalnik"
                :arMaterialPododeyalnika="arMaterialPododeyalnika"
                :currentMaterialPododeyalnika="currentMaterialPododeyalnika"
                :setProstyni="setProstyni"
                :currentProstyn="currentProstyn"
                :currentSizeProstyn="currentSizeProstyn"
                :arSizeProstyn="arSizeProstyn"
                :loadSizeProstyn="loadSizeProstyn"
                :arMaterialProstyn="arMaterialProstyn"
                :currentMaterialProstyn="currentMaterialProstyn"
                :setNavolchki="setNavolchki"
                :currentSizeNavolchki="currentSizeNavolchki"
                :currentNavolchki="currentNavolchki"
                :arSizeNavolchki="arSizeNavolchki"
                :loadSizeNavolchki="loadSizeNavolchki"
                :arMaterialNavolchki="arMaterialNavolchki"
                :currentMaterialNavolchki="currentMaterialNavolchki"
                :setValiki="setValiki"
                :currentSizeValiki="currentSizeValiki"
                :currentValiki="currentValiki"
                :arSizeValiki="arSizeValiki"
                :loadSizeValiki="loadSizeValiki"
                :arMaterialValiki="arMaterialValiki"
                :currentMaterialValiki="currentMaterialValiki"
                :setProstynUniversal="setProstynUniversal"
                :currentSizeProstynUniversal="currentSizeProstynUniversal"
                :currentProstynUniversal="currentProstynUniversal"
                :arSizeProstynUniversal="arSizeProstynUniversal"
                :loadSizeProstynUniversal="loadSizeProstynUniversal"
                :arMaterialProstynUniversal="arMaterialProstynUniversal"
                :currentMaterialProstynUniversal="currentMaterialProstynUniversal"
                :offerActual="offerActual"
                :sizeInfo="sizeInfo"
                :arSize="arSize"
                :currentMaterials="currentMaterials"
                :categories="categories"
                :fabrics="fabrics"
                :fabricsSections="fabricsSections"
                :offerIdNozhkiCurrent="offerIdNozhkiCurrent"
                :offerIdOsnovaniyaCurrent="offerIdOsnovaniyaCurrent"
                :offerIdIzgolovyaCurrent="offerIdIzgolovyaCurrent"
                :formatPrice="formatPrice"
                :priceRequestf="priceRequestf"
          ></slot>
          <slot name="tabs"></slot>
          <slot name="adds"></slot>
          <slot name="cards"
                :offerActual="offerActual"
                :deliveryPopup="deliveryPopup"
                :checkBoxberry="checkBoxberry"
                :openBoxberry="openBoxberry"
                :locationPickup="locationPickup"
                :quantity="quantity"
          ></slot>
          <slot name="services"></slot>
          <slot name="help"></slot>
        </div>
        <div class="col-span-2">
          <slot name="layers"></slot>
          <slot name="testimonials"></slot>
          <div class="pb-20">
            <slot name="problem"
                  :view_message="view_message"
                  :setShowRoomSign="setShowRoomSign"
                  :setTestDriveHome="setTestDriveHome"
            ></slot>
          </div>
        </div>
      </div>
      <slot name="alts"></slot>
      <!-- //<slot name="other"></slot>-->
      <slot name="cached"></slot>
    </div>


    <ui-in-cart-notification></ui-in-cart-notification>
    <ui-video-player></ui-video-player>
    <layout-data-popup-map></layout-data-popup-map>

    <layout-popup v-model="request3D" :sended="sended">
      <div class="s-30 w-500">Запросить 3D</div>
      <div class="s-16 opacity-80">Просто оставьте ваши данные, мы перезвоним</div>
      <template slot="form">
        <input required placeholder="Как Вас зовут" v-model="name" type="text" class="ui-input" />
        <input v-model="phone" class="ui-input" name="CLIENT_PHONE" type="tel" placeholder="Введите телефон" required />
<!--        <phone-mask-input
            v-model="phone"
            autoDetectCountry
            @onValidate="onValidate"
            name="CLIENT_PHONE"
            inputClass="ui-input"
            placeholder=""
            required
        />-->
        <ui-button @click="sendFeedback('Запросить 3D' )" style="margin-top: 2em;">Оставить заявку</ui-button>
      </template>
      <div slot="suffix" class="s-12">
        Оставляя Ваш телефон, вы соглашаетесь с политикой обработки персональных данных
      </div>
    </layout-popup>
    <layout-popup v-model="videoPresent" :sended="sended">
      <div class="s-30 w-500">Видеопрезентация</div>
      <div class="s-16 opacity-80">Просто оставьте ваши данные для связи</div>
      <template slot="form">
        <input required placeholder="Как Вас зовут" v-model="name" type="text" class="ui-input" />
        <input v-model="phone" class="ui-input" type="tel" name="CLIENT_PHONE" placeholder="Введите телефон" required />
<!--        <phone-mask-input
            v-model="phone"
            autoDetectCountry
            @onValidate="onValidate"
            name="CLIENT_PHONE"
            inputClass="ui-input"
            placeholder=""
            required
        />-->
        <ui-button @click="sendFeedback('Запросить видеопрезентацию' )" style="margin-top: 2em;">Оставить заявку</ui-button>
      </template>
      <div slot="suffix" class="s-12">
        Оставляя Ваш телефон, вы соглашаетесь с политикой обработки персональных данных
      </div>
    </layout-popup>
    <layout-popup v-model="showRoomSign" :sended="sended">
      <div class="s-30 w-500">Записаться в салон</div>
      <div class="s-16 opacity-80">Просто оставьте ваши данные, мы перезвоним</div>
      <template slot="form">
        <input required placeholder="Как Вас зовут" v-model="name" type="text" class="ui-input" />
        <input placeholder="your_email@example.com" type="email" v-model="mail" class="ui-input" />
        <input v-model="phone" class="ui-input" type="tel" name="CLIENT_PHONE" placeholder="Введите телефон" required />
<!--        <phone-mask-input
            v-model="phone"
            autoDetectCountry
            @onValidate="onValidate"
            name="CLIENT_PHONE"
            inputClass="ui-input"
            placeholder=""
            required
        />-->
        <ui-button @click="sendFeedback('Записаться в салон' )" style="margin-top: 2em;">Оставить заявку</ui-button>
      </template>
      <div slot="suffix" class="s-12">
        Оставляя Ваш email, вы соглашаетесь с политикой обработки персональных данных
      </div>
    </layout-popup>
    <layout-popup v-model="testDriveHome" :sended="sended">
      <div class="s-30 w-500">Тест-драйв на дому</div>
      <div class="s-16 opacity-80"></div>
      <template slot="form">
        <input required placeholder="Как Вас зовут" v-model="name" type="text" class="ui-input" />
        <input placeholder="your_email@example.com" type="email" v-model="mail" class="ui-input" />
        <input @focus="errorBorder" v-model="phone" class="ui-input" name="CLIENT_PHONE" type="tel" placeholder="Введите телефон" required />
<!--        <phone-mask-input
            v-model="phone"
            autoDetectCountry
            name="CLIENT_PHONE"
            @onValidate="onValidate"
            inputClass="ui-input"
            placeholder=""
            required
        />-->
        <ui-button @click="sendFeedback('Тест-драйв на дому' )" style="margin-top: 2em;">Оставить заявку</ui-button>
      </template>
      <div slot="suffix" class="s-12">
        Оставляя Ваш email, вы соглашаетесь с политикой обработки персональных данных
      </div>
    </layout-popup>
    <layout-popup v-model="priceRequest" :sended="sended">
      <div class="s-30 w-500">Рассчитать стоимость</div>
      <div class="s-16 opacity-80">Оставьте Ваш номер телефона, мы перезвоним</div>
      <template slot="form">
        <input required placeholder="Как Вас зовут" name="name" type="text" v-model="name" class="ui-input" />
        <input v-model="phone" class="ui-input" name="CLIENT_PHONE" type="tel" placeholder="Введите телефон" required />
        <ui-button @click="sendFeedback( 'Расчитать стоимость товара '+ offerActual.NAME +'.' )" >Отправить</ui-button>
      </template>
      <div slot="suffix" class="s-12">
        Оставляя Ваш телефон, вы соглашаетесь с <a class="underline" href="/politica/" title="Политика обработки персональных данных">политикой обработки персональных данных</a>
      </div>
    </layout-popup>
  </div>
</template>

<script>
export default {
  props:{
    images: [],
    grafikzhestkodti: [],
    grafikzhestkodti2: [],
    product: {}
  },
  data() {
    return {
      priceRequest: false,
      active: false,
      isMobile: false,
      activeCompare: false,
      activeFavorite: false,
      offerActual: this.product.CURRENT_OFFER,
      arSet: [],

      setPododeyalniki: [],     // все пододеяльники
      currentPododeyalnik: {}, // выбранный пододеяльник
      countPododeyalnik: 1,  // количество
      currentSizePododeyalnika: {}, // выбранный размер
      arSizesPododeyalnika: [], // массив размерв
      currentMaterialPododeyalnika: {}, // выбранный размер
      arMaterialPododeyalnika: [], // массив размерв
      loadSizePododeyalnik: true,
      offerPododeyalnik: {},

      setProstyni: [],     // все пододеяльники
      currentProstyn: {}, // выбранный пододеяльник
      countProstyn: 1,  // количество
      currentSizeProstyn: {}, // выбранный размер
      arSizeProstyn: [], // массив размерв
      currentMaterialProstyn: {}, // выбранный размер
      arMaterialProstyn: [], // массив размерв
      loadSizeProstyn: true,
      offerProstyn: {},

      setNavolchki: [],     // все пододеяльники
      currentNavolchki: {}, // выбранный пододеяльник
      countNavolchki: 1,  // количество
      currentSizeNavolchki: {}, // выбранный размер
      arSizeNavolchki: [], // массив размерв
      currentMaterialNavolchki: {}, // выбранный размер
      arMaterialNavolchki: [], // массив размерв
      loadSizeNavolchki: true,
      offerNavolchki: {},

      setValiki: [],     // все пододеяльники
      currentValiki: {}, // выбранный пододеяльник
      countValiki: 1,  // количество
      currentSizeValiki: {}, // выбранный размер
      arSizeValiki: [], // массив размерв
      currentMaterialValiki: {}, // выбранный размер
      arMaterialValiki: [], // массив размерв
      loadSizeValiki: true,
      offerValiki: {},

      setProstynUniversal: [],     // все пододеяльники
      currentProstynUniversal: {}, // выбранный пододеяльник
      countProstynUniversal: 1,  // количество
      currentSizeProstynUniversal: {}, // выбранный размер
      arSizeProstynUniversal: [], // массив размерв
      currentMaterialProstynUniversal: {}, // выбранный размер
      arMaterialProstynUniversal: [], // массив размерв
      loadSizeProstynUniversal: true,
      offerProstynUniversal: {},

      site_id: this.$store.state.langs.SITE_ID,
      sizeInfo: {},
      arSize: [],
      categories: [],
      fabrics: [],
      fabricsSections: [],
      currentMaterials: {
        image: "",
        name: "",
        id: "",
        category: null
      },
      offerIdNozhkiCurrent: null,
      offerIdOsnovaniyaCurrent: null,
      offerIdIzgolovyaCurrent: null,
      offerIdRecomendet: {},
      offerIdServices: {},
      offerIdSoputka: {},
      offerSoputka: {},
      offerNozhki: {},
      offerOsnovaniya: {},
      offerIzgolovya: {},
      offerRecomendet: {},
      offerServices: {},
      pageScroll200: false,
      showRoomSign: false,
      videoPresent: false,
      name: "",
      mail: "",
      phone: "",
      testDriveHome: false,
      sended: false,
      city: 'Москва',
      index: null,
      offerspost: false,
      validPhone: false,
      quantity: 0,
      request3D: false,
      dlina: false,
      shirina: false,
      visota: false,
      currentSize: false,
    }
  },
  components: {
    iconSide: () => import('@/components/icon/icon-side'),
    'ui-in-cart-notification': () => import('@/components/ui/ui-in-cart-notification'),
    'ui-video-player': () => import('@/components/ui/ui-video-player'),
    'ui-button': () => import('@/components/ui/ui-button.vue'),
    'layout-popup': () => import('@/components/layout/layout-popup'),
    'layout-data-popup-map': () => import('@/components/layout/layout-data-popup-map')
  },
  created() {
    this.arSize=this.product.AR_SIZE;
    this.sizeInfo=this.product.SIZE_INFO;
    this.currentMaterials.category=(this.product.MATERIAL_TYPE) ? this.product.MATERIAL_TYPE : null ;
    this.currentMaterials.name=(this.product.MATERIAL_TYPE) ? this.product.MATERIAL_TYPE : null ;
    this.categories=(this.product.MATERIAL_TYPE) ? this.product.AR_MATERIAL_TYPE : [] ;
    if( typeof this.product.PROPERTIES.TKANI != "undefined" && this.product.PROPERTIES.TKANI.VALUE.length>0){
      this.fabrics = this.product.PROPERTIES.TKANI.VALUE;
    }
    if( typeof this.product.PROPERTIES.TKANI_RAZDELY != "undefined" && this.product.PROPERTIES.TKANI_RAZDELY.VALUE.length>0){
      this.fabricsSections = this.product.PROPERTIES.TKANI_RAZDELY.VALUE;
    }
    if(
        typeof this.product.CURRENT_OFFER.PROPERTIES != "undefined" &&
        typeof this.product.CURRENT_OFFER.PROPERTIES.DLINA != "undefined" &&
        this.product.CURRENT_OFFER.PROPERTIES.DLINA.VALUE &&
        typeof this.product.CURRENT_OFFER.PROPERTIES.SHIRINA != "undefined" &&
        this.product.CURRENT_OFFER.PROPERTIES.SHIRINA.VALUE &&
        typeof this.product.PROPERTIES.VYSOTA_IZGOLOVYA != "undefined" &&
        this.product.PROPERTIES.VYSOTA_IZGOLOVYA.VALUE
    ){
      this.dlina = Number( this.product.CURRENT_OFFER.PROPERTIES.DLINA.VALUE ) + Number( this.product.PROPERTIES.PRIBAVKA_PO_DLINE_K_DLINE_SPALNOGO_MESTA_MATRASA_.VALUE );
      this.shirina = Number( this.product.CURRENT_OFFER.PROPERTIES.SHIRINA.VALUE ) + Number( this.product.PROPERTIES.PRIBAVKA_PO_SHIRINE_K_SHIRINE_SPALNOGO_META_MATRAS.VALUE );
      this.visota = this.product.PROPERTIES.VYSOTA_IZGOLOVYA.VALUE;
      this.currentSize = this.product.SIZE_INFO.current;
    }

    //комплекты пододеяльники проверяем есть все для пододеяльников комплектов
    if(this.product.TYPE_PRODUCT==='set' && typeof this.product.CODE_KOMPLEKT_PODODEYALNIKI != "undefined" && typeof this.product.PROPERTIES[this.product.CODE_KOMPLEKT_PODODEYALNIKI] != "undefined" && this.product.PROPERTIES[this.product.CODE_KOMPLEKT_PODODEYALNIKI].VALUE.length>0){
      this.requestSetProducts(this.product.PROPERTIES[this.product.CODE_KOMPLEKT_PODODEYALNIKI].VALUE, 'setPododeyalniki','currentPododeyalnik','currentSizePododeyalnika','arSizesPododeyalnika', 'currentMaterialPododeyalnika', 'arMaterialPododeyalnika');
    }

    //комплекты простыни проверяем есть все для простыней комплектов
    if(this.product.TYPE_PRODUCT==='set' && typeof this.product.CODE_KOMPLEKT_PROSTYNI != "undefined" && typeof this.product.PROPERTIES[this.product.CODE_KOMPLEKT_PROSTYNI] != "undefined" && this.product.PROPERTIES[this.product.CODE_KOMPLEKT_PROSTYNI].VALUE.length>0){
      this.requestSetProducts(this.product.PROPERTIES[this.product.CODE_KOMPLEKT_PROSTYNI].VALUE, 'setProstyni','currentProstyn','currentSizeProstyn','arSizeProstyn', 'currentMaterialProstyn', 'arMaterialProstyn');
    }

    //комплекты наволочек проверяем есть все для наволочек комплектов
    if(this.product.TYPE_PRODUCT==='set' && typeof this.product.CODE_KOMPLEKTNYE_NAVOLOCHKI != "undefined" && typeof this.product.PROPERTIES[this.product.CODE_KOMPLEKTNYE_NAVOLOCHKI] != "undefined" && this.product.PROPERTIES[this.product.CODE_KOMPLEKTNYE_NAVOLOCHKI].VALUE.length>0){
      this.requestSetProducts(this.product.PROPERTIES[this.product.CODE_KOMPLEKTNYE_NAVOLOCHKI].VALUE, 'setNavolchki','currentNavolchki','currentSizeNavolchki','arSizeNavolchki', 'currentMaterialNavolchki', 'arMaterialNavolchki');
    }

    //комплекты наволочек проверяем есть все для наволочек комплектов
    if(this.product.TYPE_PRODUCT==='set' && typeof this.product.CODE_KOMPLEKTNYE_VALIKI != "undefined" && typeof this.product.PROPERTIES[this.product.CODE_KOMPLEKTNYE_VALIKI] != "undefined" && this.product.PROPERTIES[this.product.CODE_KOMPLEKTNYE_VALIKI].VALUE.length>0){
      this.requestSetProducts(this.product.PROPERTIES[this.product.CODE_KOMPLEKTNYE_VALIKI].VALUE, 'setValiki','currentValiki','currentSizeValiki','arSizeValiki', 'currentMaterialValiki', 'arMaterialValiki');
    }

    //комплекты Простынь универсальная проверяем есть все для Простынь универсальная комплектов
    if(this.product.TYPE_PRODUCT==='set' && typeof this.product.CODE_KOMPLEKT_PROSTYN_UNIVERSALNAYA != "undefined" && typeof this.product.PROPERTIES[this.product.CODE_KOMPLEKT_PROSTYN_UNIVERSALNAYA] != "undefined" && this.product.PROPERTIES[this.product.CODE_KOMPLEKT_PROSTYN_UNIVERSALNAYA].VALUE.length>0){
      this.requestSetProducts(this.product.PROPERTIES[this.product.CODE_KOMPLEKT_PROSTYN_UNIVERSALNAYA].VALUE, 'setProstynUniversal','currentProstynUniversal','currentSizeProstynUniversal','arSizeProstynUniversal', 'currentMaterialProstynUniversal', 'arMaterialProstynUniversal');
    }

    this.$bus.$on('updateSetProduct', (prod) => {
      this[prod.currentName] = prod.current;
      this[prod.arSizeName] = [];
      this[prod.arMaterialName] = [];
      if( prod.current.OFFERS.length > 1 ){
        prod.current.OFFERS.forEach((offer, index) => {
          this[prod.arSizeName].push(offer.PROPERTIES.GABARITY.VALUE);
          if( offer.PROPERTIES.MATERIAL_TYPE && offer.PROPERTIES.MATERIAL_TYPE.VALUE ) {
            this[arMaterialName].push(offer.PROPERTIES.MATERIAL_TYPE.VALUE);
          }
        });
        this.updateSetPrice();
      }else{
        this.$axios({
          url: '/ajax/offers-product.php?id=' + prod.current.ID,
          method: 'post',
          data: {}
        }).then(response => {
          if (response.status == 200) {
            let dataProduct = response.data
            this[prod.currentName].OFFERS = dataProduct;
            let size = [];
            let sizeMaterial = [];
            dataProduct.forEach((offer, index) => {
              if( offer.PROPERTIES.GABARITY && offer.PROPERTIES.GABARITY.VALUE ) {
                size.push(offer.PROPERTIES.GABARITY.VALUE);
              }
              if( offer.PROPERTIES.MATERIAL_TYPE && offer.PROPERTIES.MATERIAL_TYPE.VALUE ) {
                sizeMaterial.push(offer.PROPERTIES.MATERIAL_TYPE.VALUE);
              }
            });
            this[prod.arSizeName]=[...new Set(size)];
            this[prod.arMaterialName]=[...new Set(sizeMaterial)];
            this.updateSetPrice();
          } else {
            console.log("request updateSetProduct requestSetProductsOne error")
          }
        }).catch(e => {
          console.log('Error: ' + e);
        })
      }
    });
    this.$bus.$on('updateCount', (count) => {
      this[count.countPropName] = count.count;
      this.updateSetPrice();
    });
    this.$bus.$on('updateOffers', (infoOb) => {
      this.requestSetProductOffersOne(infoOb.id, infoOb.currentName, infoOb.arSizeName, infoOb.arMaterialName, infoOb.loadSizeName);
    });
    this.$bus.$on('updateSetSize', (size) => {
      this[size.currentSizeName].name = size.name;
      this.updateSetPrice();
    });
    this.$bus.$on('updateMaterialsSet', (cat) => {
      this[cat.currentMaterialName].name=cat.CATEGORY;
      this[cat.currentMaterialName].subName=cat.NAME;
      this[cat.currentMaterialName].color=cat.COLOR;
      this.updateSetPrice();
    });

    var cookieCompare = this.$cookie.get('compare');
    if( cookieCompare ){
      var compareJson = JSON.parse(cookieCompare);
      if(compareJson[this.site_id] && compareJson[this.site_id][this.offerActual.IBLOCK_ID] && compareJson[this.site_id][this.offerActual.IBLOCK_ID].find(el => el === this.offerActual.ID)){
        this.activeCompare = true;
      }else{
        this.activeCompare = false;
      }
    }
    var cookieFavorite = this.$cookie.get('favorites');
    if( cookieFavorite ){
      var favoriteJson = JSON.parse(cookieFavorite);
      if(this.offerActual && favoriteJson[this.site_id] && favoriteJson[this.site_id][this.offerActual.IBLOCK_ID] && favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].find(el => el === this.offerActual.ID)){
        this.activeFavorite = true;
      }else{
        this.activeFavorite = false;
      }
    }

    this.$bus.$on('updateSize', (name) => {
      this.product.SIZE_INFO.current=name;
      this.updateOfferActual();
    });
    this.$bus.$on('updateSizeHaractiristic', (name) => {
      let dlinashirina = name.split('x');
      this.dlina = Number( dlinashirina[0] ) + Number( this.product.PROPERTIES.PRIBAVKA_PO_DLINE_K_DLINE_SPALNOGO_MESTA_MATRASA_.VALUE );
      this.shirina = Number( dlinashirina[1] ) + Number( this.product.PROPERTIES.PRIBAVKA_PO_SHIRINE_K_SHIRINE_SPALNOGO_META_MATRAS.VALUE );
      this.currentSize = name;
    });
    this.$bus.$on('updateMaterials', (cat) => {
      this.currentMaterials.image=cat.DETAIL_PICTURE;
      this.currentMaterials.name=cat.NAME_OFFER+" "+cat.CATEGORY;
      this.currentMaterials.category=cat.CATEGORY;
      this.currentMaterials.id=cat.ID_OFFER;
      this.updateOfferActual();
    });
    this.$bus.$on('updateCurrentMaterials', (cat) => {
      this.currentMaterials.image=cat.DETAIL_PICTURE;
      this.currentMaterials.name=cat.NAME_OFFER+" "+cat.CATEGORY;
      this.currentMaterials.category=cat.CATEGORY;
      this.currentMaterials.id=cat.ID_OFFER;
    });
    this.$bus.$on('updateDopProductId', (prod) => {
      this[prod.propName] = prod.id;
      //this.$set(this[prod.propName], prod.id, !this[prod.propName][prod.id]);
    });
    this.$bus.$on('updateDopProduct', (prod) => {
      this[prod.propName] = prod.current;
    });
    this.$bus.$on('updateAddProductId', (prod) => {
      this.$set(this[prod.propName], prod.id, !this[prod.propName][prod.id]);
    });
    this.$bus.$on('updateAddProduct', (prod) => {
      this.$set(this[prod.propName], prod.current.ID, prod.current);
    });
    this.$bus.$on('sendProductsToCard', () => {
      this.addProductsToCard();
    });
    this.$bus.$on('sendOneAddOrder', (phone) => {
      this.oneAddOrder(phone);
    });
    this.$bus.$on('updateSended', () => {
      this.sended=false;
      this.showRoomSign=false;
      this.videoPresent=false;
      this.request3D=false;
      this.priceRequest=false;
    });
    var cookieCity = this.$cookie.get('city');
    if(cookieCity){
      this.city=cookieCity;
    }
    window.addEventListener('scroll', () => {
      if(!this.pageScroll200 && pageYOffset > 200){
        this.pageScroll200 = true;
        this.imagesView();
      }
    });

    /*
    if( this.product.OFFERS ){
      this.product.OFFERS.forEach((offer, index) => {
        if(offer.ID === this.offerActual.ID) {
          if(this.product.SIZE_INFO && this.product.SIZE_INFO.name){

          }


          this.selected_size = (typeof offer.PROPERTIES[this.$store.state.langs.CODE_SIZE] != "undefined") ? offer.PROPERTIES[this.$store.state.langs.CODE_SIZE].VALUE : null;
          this.selected_category = (typeof offer.PROPERTIES[this.$store.state.langs.MATERIAL] != "undefined") ? offer.PROPERTIES[this.$store.state.langs.MATERIAL].VALUE : null;
        }
        if( typeof offer.PROPERTIES[this.$store.state.langs.CODE_SIZE] != "undefined" ){
          offer.sizes = offer.PROPERTIES[this.$store.state.langs.CODE_SIZE];
          if( offer.sizes.VALUE ){
            this.sizes.push(offer.sizes.VALUE);
          }
          if( this.product.OFFER_CURRENT_ID > 0 && offer.ID == this.product.OFFER_CURRENT_ID ){
            this.selected_size = offer.sizes.VALUE
          }
        }
        if( typeof offer.PROPERTIES[this.$store.state.langs.MATERIAL] != "undefined"){
          offer.materials = offer.PROPERTIES[this.$store.state.langs.MATERIAL];
          if( offer.materials.VALUE ) {
            this.categories.push(offer.materials.VALUE);
            //this.materials[offer.materials.VALUE]=offer.materials.VALUE;
          }
          if( this.product.OFFER_CURRENT_ID > 0 && offer.ID == this.product.OFFER_CURRENT_ID ){
            this.selected_category = offer.materials.VALUE
          }
        }

      });

      this.sizes = [...new Set(this.sizes)];
      this.categories = [...new Set(this.categories)];
      this.sizes.sort();
      this.categories.sort();
    }
    */
    if( this.product.OFFERS.length ) {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        "ecommerce": {
          "currencyCode": "RUB",
          "detail": {
            "products": [
              {
                "id": this.offerActual.ID,
                "name": this.offerActual.NAME, // Название товара
                "price": this.offerActual.MIN_PRICE.DISCOUNT_VALUE, //Стоимость единицы товара
                "brand": this.product.PROPERTIES.PROIZVODITEL.VALUE,//Название бренда
                "category": this.product.iblockInfo.NAME + "/" + this.product.PROPERTIES.PROIZVODITEL.VALUE + "/" + this.product.NAME, //Категория каталога, которой принадлежит товар
                "variant": this.sizeInfo.current //Размеры изделия
              }
            ]
          }
        }
      });
    }
    this.$bus.$on('updateIndex', (index) => {
      this.index=index;
      this.$refs.lightbox.showImage(index);
    });
    this.$bus.$on('addProductToCard', (prod) => {
      this.addProductToCard(prod);
    });
    this.quantity = this.product.CATALOG_QUANTITY;
    this.$bus.$on('videoPresent', () => {
      this.videoPresent=true;
    });

    /*const url = 'https://pay.yandex.ru/sdk/v1/pay.js';
    let yaPaYScript = document.createElement('script');
    yaPaYScript.setAttribute('src', url);
    yaPaYScript.setAttribute('async', true);
    document.head.appendChild(yaPaYScript);*/

    this.$bus.$emit('mainUpdatePrice', this.offerActual.MIN_PRICE.DISCOUNT_VALUE);

    this.isMobile = (window.innerWidth < 768);
  },
  methods: {
    getNameOffer(){
      if( this.offerActual.IBLOCK_ID === "102" ){
        return "Матрас " + this.offerActual.NAME;
      }else {
        return this.offerActual.NAME;
      }
    },
    request3Df(){
      this.request3D=true;
    },
    priceRequestf(){
      this.priceRequest=true;
    },
    formatPrice(price) {
      return Math.ceil(Number(price)).toLocaleString() + " <span class='ruble'>"+ this.$store.state.langs.CURRENCY_SING+"</span>"
    },
    formatPriceDolyame(price) {
      return "4 платежа по " + Math.ceil(Number(price)/4).toLocaleString() + " <span class='ruble'>"+ this.$store.state.langs.CURRENCY_SING+"</span>"
    },
    checkCompare(){
      this.activeCompare = !this.activeCompare;
      var cookieCompare = this.$cookie.get('compare');
      var compareJson = {};
      if( cookieCompare ){
        compareJson = JSON.parse(cookieCompare);
        if( this.activeCompare ) { //add
          if( !compareJson[this.site_id] ){
            compareJson[this.site_id]={};
            compareJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
            compareJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          if( !compareJson[this.site_id][this.offerActual.IBLOCK_ID] ){
            compareJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
            compareJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          var searchId = compareJson[this.site_id][this.offerActual.IBLOCK_ID].find(el => el === this.offerActual.ID);
          if( !searchId ){
            compareJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'add2comparison');
          }
        }else{ // remove
          compareJson[this.site_id][this.offerActual.IBLOCK_ID] = compareJson[this.site_id][this.offerActual.IBLOCK_ID].filter((n) => {return n != this.offerActual.ID});
        }
      }else{
        compareJson[this.site_id]={};
        compareJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
        compareJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
      }
      this.$cookie.set('compare', JSON.stringify(compareJson))
      var cuntCompare = 0;
      for (var key in compareJson[this.site_id]) {
        cuntCompare = cuntCompare + compareJson[this.site_id][key].length;
      }
      this.$bus.$emit("compare", cuntCompare);
    },
    checkFavorite(){
      this.activeFavorite = !this.activeFavorite;
      var cookieFavorite = this.$cookie.get('favorites');
      var favoriteJson = {};
      if( cookieFavorite ){
        favoriteJson = JSON.parse(cookieFavorite);
        if( this.activeFavorite ) { //add
          if( !favoriteJson[this.site_id] ){
            favoriteJson[this.site_id]={};
            favoriteJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
            favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          if( !favoriteJson[this.site_id][this.offerActual.IBLOCK_ID] ){
            favoriteJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
            favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          var searchId = favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].find(el => el === this.offerActual.ID);
          if( !searchId ){
            favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'add2favorites');

            let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
            ym(yaCounterId2, 'reachGoal', 'favorites');
          }
        }else{ // remove
          favoriteJson[this.site_id][this.offerActual.IBLOCK_ID] = favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].filter((n) => {return n != this.offerActual.ID});
        }
      }else{
        favoriteJson[this.site_id]={};
        favoriteJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
        favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
      }
      this.$cookie.set('favorites', JSON.stringify(favoriteJson))
      var cuntFavorites = 0;
      for (var key in favoriteJson[this.site_id]) {
        cuntFavorites = cuntFavorites + favoriteJson[this.site_id][key].length;
      }
      this.$bus.$emit("favorite", cuntFavorites);
    },
    updateOfferActual(){
      this.offerIdSoputka = null;
      let currentOffer = {}
      let name = this.product.SIZE_INFO.current;
      if( this.currentMaterials.category ) {
        currentOffer = this.product.OFFERS.find(offer => (offer.PROPERTIES.GABARITY.VALUE === name && offer.PROPERTIES.MATERIAL_TYPE.VALUE === this.currentMaterials.category));
      }else{
        currentOffer = this.product.OFFERS.find(offer => (offer.PROPERTIES.GABARITY.VALUE === name));
      }
      if(currentOffer) {
        this.sizeInfo.current = currentOffer.PROPERTIES.GABARITY.VALUE;
        this.sizeInfo.nal = (Number(currentOffer.CATALOG_QUANTITY) > 0 || currentOffer.STORE || currentOffer.STORE_UD_SKLAD) ? "В наличии" : "";
        this.offerActual = currentOffer;
        window.history.pushState({"currentOffer":currentOffer.ID}, currentOffer.NAME, '/catalog/' + currentOffer.CODE + '/');
      }
      this.$bus.$emit('mainUpdatePrice', this.offerActual.MIN_PRICE.DISCOUNT_VALUE);

    },
    addProductsToCard(){
      var ids = [];
      var products = [];
      if(this.product.TYPE_PRODUCT !== 'set') {
        ids.push(this.offerActual.ID);
      }
      let brand = ( this.product.PROPERTIES.PROIZVODITEL &&  this.product.PROPERTIES.PROIZVODITEL.VALUE) ? this.product.PROPERTIES.PROIZVODITEL.VALUE : "" ;
      let prodActual = {
        "id": this.offerActual.ID,
        "name" : this.offerActual.NAME,
        "price": this.offerActual.MIN_PRICE.DISCOUNT_VALUE,
        "brand": brand,
        "category":  this.product.iblockInfo.NAME + "/" + brand + "/" + this.product.NAME,
        "variant" : this.sizeInfo.current,
        "quantity": 1
      }
      products.push(prodActual);
      if( this.offerIdNozhkiCurrent ){
        ids.push(this.offerIdNozhkiCurrent);
        if( this.offerNozhki ){
          let offerNozhki = {
            "id": this.offerNozhki.id,
            "name" : this.offerNozhki.name,
            "price": this.offerNozhki.price,
            "brand": this.offerNozhki.brand,
            "category":  this.product.iblockInfo.NAME + "/" + this.offerNozhki.brand + "/" + this.offerNozhki.name,
            "quantity": 1
          }
          products.push(offerNozhki);
        }

      }
      if( this.offerIdOsnovaniyaCurrent ){
        ids.push(this.offerIdOsnovaniyaCurrent);
        if( this.offerOsnovaniya ){
          let offerOsnovaniya = {
            "id": this.offerOsnovaniya.id,
            "name" : this.offerOsnovaniya.name,
            "price": this.offerOsnovaniya.price,
            "brand": this.offerOsnovaniya.brand,
            "category":  this.product.iblockInfo.NAME + "/" + this.offerOsnovaniya.brand + "/" + this.offerOsnovaniya.name,
            "quantity": 1
          }
          products.push(offerOsnovaniya);
        }
      }
      if( this.offerIdIzgolovyaCurrent ){
        ids.push(this.offerIdIzgolovyaCurrent);
        if( this.offeIzgolovya ) {
          let offeIzgolovya = {
            "id": this.offeIzgolovya.id,
            "name": this.offeIzgolovya.name,
            "price": this.offeIzgolovya.price,
            "brand": this.offeIzgolovya.brand,
            "category": this.product.iblockInfo.NAME + "/" + this.offeIzgolovya.brand + "/" + this.offeIzgolovya.name,
            "quantity": 1
          }
          products.push(offeIzgolovya);
        }
      }
      /*
      for (const [id, flag] of Object.entries(this.offerIdRecomendet)) {
        if(flag && this.offerRecomendet[id].MIN_PRICE && this.offerRecomendet[id].MIN_PRICE.DISCOUNT_VALUE) {
          ids.push(id);
          let brand = ( this.offerRecomendet[id].PROPERTIES.PROIZVODITEL &&  this.offerRecomendet[id].PROPERTIES.PROIZVODITEL.VALUE) ? this.offerRecomendet[id].PROPERTIES.PROIZVODITEL.VALUE : "" ;
          let prodRecomendet = {
            "id": this.offerRecomendet[id].ID,
            "name" : this.offerRecomendet[id].NAME,
            "price": this.offerRecomendet[id].MIN_PRICE.DISCOUNT_VALUE,
            "brand": brand,
            "category":  this.product.iblockInfo.NAME + "/" + brand + "/" + this.offerRecomendet[id].NAME,
            "variant" : ( this.offerRecomendet[id].PROPERTIES.GABARITY && this.offerRecomendet[id].PROPERTIES.GABARITY.VALUE ) ? this.offerRecomendet[id].PROPERTIES.GABARITY.VALUE : "",
            "quantity": 1
          }
          products.push(prodRecomendet);
        }
      }
      */
      if(this.offerIdSoputka) {
        for (const [id, flag] of Object.entries(this.offerIdSoputka)) {
          if (flag && this.offerSoputka[id].MIN_PRICE && this.offerSoputka[id].MIN_PRICE.DISCOUNT_VALUE) {
            ids.push(id);
            let brand = (this.offerSoputka[id].PROPERTIES.PROIZVODITEL && this.offerSoputka[id].PROPERTIES.PROIZVODITEL.VALUE) ? this.offerSoputka[id].PROPERTIES.PROIZVODITEL.VALUE : "";
            let prodSoputka = {
              "id": this.offerSoputka[id].ID,
              "name": this.offerSoputka[id].NAME,
              "price": this.offerSoputka[id].MIN_PRICE.DISCOUNT_VALUE,
              "brand": brand,
              "category": this.product.iblockInfo.NAME + "/" + brand + "/" + this.offerSoputka[id].NAME,
              "variant": (this.offerSoputka[id].PROPERTIES.GABARITY && this.offerSoputka[id].PROPERTIES.GABARITY.VALUE) ? this.offerSoputka[id].PROPERTIES.GABARITY.VALUE : "",
              "quantity": 1
            }
            products.push(prodSoputka);
          }
        }
      }
      for (const [id, flag] of Object.entries(this.offerIdServices)) {
        if(flag) {
          ids.push(id);
          let prodServices = {
            "id": this.offerServices[id].ID,
            "name" : this.offerServices[id].NAME,
            "price": this.offerServices[id].PRICE,
            "brand": "",
            "category":  "services/" + this.offerServices[id].NAME,
            "variant" : "",
            "quantity": 1
          }
          products.push(prodServices);
        }
      }

      var bodyFormData = new FormData();

      if( this.currentMaterials && this.currentMaterials.id ){
        bodyFormData.append('material_id', this.currentMaterials.id);
        bodyFormData.append('material_name', this.currentMaterials.name);
      }

      bodyFormData.append('id', ids);
      bodyFormData.append('add_basket', 'Y');
      bodyFormData.append('CATALOG_ID', this.$store.state.langs.CATALOG_ID);
      bodyFormData.append('GROUP_USER_ID', this.$store.state.langs.GROUP_USER_ID);
      bodyFormData.append('SITE_ID', this.$store.state.siteid);

      if(this.product.TYPE_PRODUCT=='set'){
        bodyFormData.append('type', 'set');
        bodyFormData.append('idSet', this.offerActual.ID);

        let idSets = [];
        if( this.countPododeyalnik > 0 && this.offerPododeyalnik && this.offerPododeyalnik.ID ){
          idSets.push(this.offerPododeyalnik.ID);
          bodyFormData.append('count'+this.offerPododeyalnik.ID, this.countPododeyalnik);
        }
        if( this.countProstyn > 0 && this.offerProstyn && this.offerProstyn.ID ){
          idSets.push(this.offerProstyn.ID);
          bodyFormData.append('count'+this.offerProstyn.ID, this.countProstyn);
        }
        if( this.countNavolchki && this.offerNavolchki && this.offerNavolchki.ID ){
          idSets.push(this.offerNavolchki.ID);
          bodyFormData.append('count'+this.offerNavolchki.ID, this.countNavolchki);
        }
        if( this.countValiki && this.offerValiki && this.offerValiki.ID ){
          idSets.push(this.offerValiki.ID);
          bodyFormData.append('count'+this.offerValiki.ID, this.countValiki);
        }
        if( this.countProstynUniversal > 0 && this.offerProstynUniversal && this.offerProstynUniversal.ID ){
          idSets.push(this.offerProstynUniversal.ID);
          bodyFormData.append('count'+this.offerProstynUniversal.ID, this.countProstynUniversal);
        }
        if(!idSets.length){
          this.$notify({group: 'error-form', title: 'error', text: "Как минимум один товар нужно выбрать", type: 'error'});
          return false;
        }
        bodyFormData.append('idSets', idSets);
      }
      dataLayer.push({
        "ecommerce": {
          "currencyCode": "RUB",
          "add": {
            "products": products
          }
        }
      });
      if (typeof (ym) === "function") {
        let yaCounterId = this.$store.state.langs.YACOUNTER;
        ym(yaCounterId, 'reachGoal', 'add2cart');

        let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
        ym(yaCounterId2, 'reachGoal', 'add_to_cart');
      }
      this.$axios({
          url: '/ajax/',
          headers: { "Content-Type": "multipart/form-data" },
          method: 'post',
          data: bodyFormData
        //url: '/ajax/?id='+ids+'&add_basket=Y&CATALOG_ID='+this.$store.state.langs.CATALOG_ID+'&GROUP_USER_ID='+this.$store.state.langs.GROUP_USER_ID+'&SITE_ID='+this.$store.state.langs.SITE_ID, method: 'post'
      }).then(response => {
        if (response.status == 200) {
          //console.log('response', response)
          var count = Number(response.data.productCount);
          this.$bus.$emit("smallbasket", count);
          let productBascet = {name:this.offerActual.NAME,price:this.formatPrice( this.offerActual.MIN_PRICE.DISCOUNT_VALUE ),image:this.product.DETAIL_PICTURE.SRC}
          this.$bus.$emit('in-cart', productBascet);
        }
      }).catch(e => {
        console.log('Error: ' + e)
      });
    },
    addProductToCard(prod){
      var ids = [];
      ids.push(prod.ID);
      var bodyFormData = new FormData();
      bodyFormData.append('id', ids);
      bodyFormData.append('add_basket', 'Y');
      bodyFormData.append('CATALOG_ID', this.$store.state.langs.CATALOG_ID);
      bodyFormData.append('GROUP_USER_ID', this.$store.state.langs.GROUP_USER_ID);
      bodyFormData.append('SITE_ID', this.$store.state.siteid);
      if (typeof (ym) === "function") {
        let yaCounterId = this.$store.state.langs.YACOUNTER;
        ym(yaCounterId, 'reachGoal', 'add2cart');

        let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
        ym(yaCounterId2, 'reachGoal', 'add_to_cart');

      }
      this.$axios({
        url: '/ajax/',
        headers: { "Content-Type": "multipart/form-data" },
        method: 'post',
        data: bodyFormData
        //url: '/ajax/?id='+ids+'&add_basket=Y&CATALOG_ID='+this.$store.state.langs.CATALOG_ID+'&GROUP_USER_ID='+this.$store.state.langs.GROUP_USER_ID+'&SITE_ID='+this.$store.state.langs.SITE_ID, method: 'post'
      }).then(response => {
        if (response.status == 200) {
          //console.log('response', response)
          var count = Number(response.data.productCount);
          this.$bus.$emit("smallbasket", count);
          let productBascet = {name:prod.NAME,price:this.formatPrice( prod.OFFERS[0].MIN_PRICE.DISCOUNT_VALUE ),image:prod.DETAIL_PICTURE.SRC}
          this.$bus.$emit('in-cart', productBascet);
        }
      }).catch(e => {
        console.log('Error: ' + e)
      });
    },
    oneAddOrder(phone){

      let inputTelVal = this.phone.replace(/^\D+/g, '').replace(/[^0-9]/g, '');
      const PHONE_REGEXP = /^\d+$/;
      const prone = PHONE_REGEXP.test(inputTelVal);
      if( !prone || ( typeof inputTelVal.length === "undefined" ||  inputTelVal.length < 7) ){
        document.querySelector('input[type="tel"]').classList.add('error');
        return false;
      } else {
        document.querySelector('input[type="tel"]').classList.remove('error');
      }

      var ids = [];
      var products = [];
      ids.push(this.offerActual.ID);
      let brand = ( this.product.PROPERTIES.PROIZVODITEL &&  this.product.PROPERTIES.PROIZVODITEL.VALUE) ? this.product.PROPERTIES.PROIZVODITEL.VALUE : "" ;
      let prodActual = {
        "id": this.offerActual.ID,
        "name" : this.offerActual.NAME,
        "price": this.offerActual.MIN_PRICE.DISCOUNT_VALUE,
        "brand": brand,
        "category":  this.product.iblockInfo.NAME + "/" + brand + "/" + this.product.NAME,
        "variant" : this.sizeInfo.current,
        "quantity": 1
      }
      products.push(prodActual);

      if( this.offerIdNozhkiCurrent ){
        ids.push(this.offerIdNozhkiCurrent);
        if( this.offerNozhki ){
          let offerNozhki = {
            "id": this.offerNozhki.id,
            "name" : this.offerNozhki.name,
            "price": this.offerNozhki.price,
            "brand": this.offerNozhki.brand,
            "category":  this.product.iblockInfo.NAME + "/" + this.offerNozhki.brand + "/" + this.offerNozhki.name,
            "quantity": 1
          }
          products.push(offerNozhki);
        }

      }
      if( this.offerIdOsnovaniyaCurrent ){
        ids.push(this.offerIdOsnovaniyaCurrent);
        if( this.offerOsnovaniya ){
          let offerOsnovaniya = {
            "id": this.offerOsnovaniya.id,
            "name" : this.offerOsnovaniya.name,
            "price": this.offerOsnovaniya.price,
            "brand": this.offerOsnovaniya.brand,
            "category":  this.product.iblockInfo.NAME + "/" + this.offerOsnovaniya.brand + "/" + this.offerOsnovaniya.name,
            "quantity": 1
          }
          products.push(offerOsnovaniya);
        }
      }
      if( this.offerIdIzgolovyaCurrent ){
        ids.push(this.offerIdIzgolovyaCurrent);
        if( this.offeIzgolovya ) {
          let offeIzgolovya = {
            "id": this.offeIzgolovya.id,
            "name": this.offeIzgolovya.name,
            "price": this.offeIzgolovya.price,
            "brand": this.offeIzgolovya.brand,
            "category": this.product.iblockInfo.NAME + "/" + this.offeIzgolovya.brand + "/" + this.offeIzgolovya.name,
            "quantity": 1
          }
          products.push(offeIzgolovya);
        }
      }
      /*
      for (const [id, flag] of Object.entries(this.offerIdRecomendet)) {
        if(flag) {
          ids.push(id);
          let brand = ( this.offerRecomendet[id].PROPERTIES.PROIZVODITEL &&  this.offerRecomendet[id].PROPERTIES.PROIZVODITEL.VALUE) ? this.offerRecomendet[id].PROPERTIES.PROIZVODITEL.VALUE : "" ;
          let prodRecomendet = {
            "id": this.offerRecomendet[id].ID,
            "name" : this.offerRecomendet[id].NAME,
            "price": this.offerRecomendet[id].MIN_PRICE.DISCOUNT_VALUE,
            "brand": brand,
            "category":  this.product.iblockInfo.NAME + "/" + brand + "/" + this.offerRecomendet[id].NAME,
            "variant" : ( this.offerRecomendet[id].PROPERTIES.GABARITY && this.offerRecomendet[id].PROPERTIES.GABARITY.VALUE ) ? this.offerRecomendet[id].PROPERTIES.GABARITY.VALUE : "",
            "quantity": 1
          }
          products.push(prodRecomendet);
        }
      }
      */
      if(this.offerIdSoputka) {
        for (const [id, flag] of Object.entries(this.offerIdSoputka)) {
          if (flag) {
            ids.push(id);
            let brand = (this.offerSoputka[id].PROPERTIES.PROIZVODITEL && this.offerSoputka[id].PROPERTIES.PROIZVODITEL.VALUE) ? this.offerSoputka[id].PROPERTIES.PROIZVODITEL.VALUE : "";
            let prodSoputka = {
              "id": this.offerSoputka[id].ID,
              "name": this.offerSoputka[id].NAME,
              "price": this.offerSoputka[id].MIN_PRICE.DISCOUNT_VALUE,
              "brand": brand,
              "category": this.product.iblockInfo.NAME + "/" + brand + "/" + this.offerSoputka[id].NAME,
              "variant": (this.offerSoputka[id].PROPERTIES.GABARITY && this.offerSoputka[id].PROPERTIES.GABARITY.VALUE) ? this.offerSoputka[id].PROPERTIES.GABARITY.VALUE : "",
              "quantity": 1
            }
            products.push(prodSoputka);
          }
        }
      }
      for (const [id, flag] of Object.entries(this.offerIdServices)) {
        if(flag) {
          ids.push(id);
          let prodServices = {
            "id": this.offerServices[id].ID,
            "name" : this.offerServices[id].NAME,
            "price": this.offerServices[id].PRICE,
            "brand": "",
            "category":  "services/" + this.offerServices[id].NAME,
            "variant" : "",
            "quantity": 1
          }
          products.push(prodServices);
        }
      }

      dataLayer.push({
        "ecommerce": {
          "currencyCode": "RUB",
          "add": {
            "products": products
          }
        }
      });
      if (typeof (ym) === "function") {
        let yaCounterId = this.$store.state.langs.YACOUNTER;
        ym(yaCounterId, 'reachGoal', 'add2cart');
      }
      this.$axios({
        url: '/ajax/?id='+ids+'&by_one_click=Y&siteid='+this.$store.state.siteid+'&phone='+phone, method: 'post'
      }).then(response => {
        if (response.status == 200) {
          //console.log('response: ' + response)
          dataLayer.push({
            "ecommerce": {
              "purchase": {
                "actionField": {
                  "id" : response.data.order.ORDER_ID, //Уникальный ID транзакции, обязательный параметр
                  "coupon" : "",//Промокод или сертификат, введенные пользователем  при заказе
                  "revenue":  response.data.order.ORDER_PRICE //Общий доход по транзакции
                },
                "products": products
              }
            }
          });
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'order1click_Item');
            ym(yaCounterId, 'reachGoal', 'all_orders');

            let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
            ym(yaCounterId2, 'reachGoal', 'buy_1_click');
            ym(yaCounterId2, 'reachGoal', 'all_forms');
          }
        }
      }).catch(e => {
        console.log('Error: ' + e)
      });
    },
    onValidate(ev){
      this.validPhone = !!ev.isValidByLibPhoneNumberJs;
    },
    sendFeedback( text ) {
      /*if( !this.validPhone ){
        this.showError("CLIENT_PHONE");
        return false;
      } else {
        this.hideError("CLIENT_PHONE");
      }*/
      let inputTelVal = this.phone.replace(/^\D+/g, '').replace(/[^0-9]/g, '');
      const PHONE_REGEXP = /^\d+$/;
      const prone = PHONE_REGEXP.test(inputTelVal);
      if( !prone || ( typeof inputTelVal.length === "undefined" ||  inputTelVal.length < 7) ){
        document.querySelector('input[type="tel"]').classList.add('error');
        return false;
      } else {
        document.querySelector('input[type="tel"]').classList.remove('error');
      }

      //const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

      /*if( this.email == "" || !EMAIL_REGEXP.test(this.email) ){
        this.showError("CLIENT_EMAIL");
        return false;
      } else {
        this.hideError("CLIENT_EMAIL");
      }*/


      //if( this.name==="" || this.phone==="" ){
        //this.$notify({group: 'error-form', title: 'error', text: this.$store.state.langs.NOTIFICATION_ERROR_FIELD, type: 'error'});
       // return false;
      //}
      this.$axios({
        url: '/ajax/?feadback=Y',
        method: 'post',
        params: {
          name: this.name,
          email: this.mail,
          phone: this.phone,
          text: text,
          header: text,
          url: location.href
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          //console.log( "response", response );

          if(text=='Записаться в салон'){
            if (typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', 'salon_sentForm');

              let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
              ym(yaCounterId2, 'reachGoal', 'showroom');
              ym(yaCounterId2, 'reachGoal', 'all_forms');
            }
          }else if(text=='Тест-драйв на дому'){
            if (typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', 'test_drive_sentForm');

              let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
              ym(yaCounterId2, 'reachGoal', 'fitting_at_home');
              ym(yaCounterId2, 'reachGoal', 'all_forms');
            }
          }

          this.sended = true;
        }else{
          console.log('Error feedback success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
      //this.loading = false;
    },
    showError(propertyName) {
      const el = document.getElementsByName(propertyName);
      if (el[0].hasChildNodes) {
        const error = el[0].querySelector(".error-message")
        if (error === null) {
          let div = document.createElement("div")
          div.classList.add("error-message")
          div.append("Заполните это поле")
          el[0].append(div)
          let inp = el[0].querySelector('input');
          inp.classList.add("error")
        }
      }
    },
    hideError(propertyName) {
      const el = document.getElementsByName(propertyName)
      if (el.length > 0) {
        let inp = el[0].querySelector('input');
        inp.classList.remove("error");
        let messageError = el[0].querySelector('.error-message');
        if(messageError) {
          messageError.remove();
        }
      }
    },
    view_message(){
      if(typeof callibriOpenWidgetClick == "function"){
        callibriOpenWidgetClick(event,'callibri_chatW','switchForChat',this)
      }
      if(typeof ym == "function") {
        let yaCounterId = this.$store.state.langs.YACOUNTER;
        ym(yaCounterId, 'reachGoal', 'go2callibri_chat');
      }
    },
    dolyamePopup(){
      this.$bus.$emit('openedPopup','dolyame-modal');
    },
    updateSetPrice(){// обновялем цену
      let price = 0;
      if( typeof this.currentPododeyalnik != "undefined" && Object.keys(this.currentPododeyalnik).length ){
        let offerPododeyalniki = {}
        if( typeof this.currentMaterialPododeyalnika.name !== "undefined" && this.currentMaterialPododeyalnika.name !== "" ){
          offerPododeyalniki = this.currentPododeyalnik.OFFERS.find(offer => {
              return offer.PROPERTIES.GABARITY.VALUE === this.currentSizePododeyalnika.name &&
              offer.PROPERTIES.MATERIAL_TYPE.VALUE === this.currentMaterialPododeyalnika.name
            }
          );
        }else{
          offerPododeyalniki = this.currentPododeyalnik.OFFERS.find(offer => offer.PROPERTIES.GABARITY.VALUE === this.currentSizePododeyalnika.name );
        }
        if( typeof offerPododeyalniki === "undefined"){
          console.log("offerPododeyalniki не найдено размеров", offerPododeyalniki);
        }
        this.offerPododeyalnik=offerPododeyalniki;
        price = price+( Number(offerPododeyalniki.MIN_PRICE.DISCOUNT_VALUE) * this.countPododeyalnik );
      }
      if( typeof this.currentProstyn != "undefined" && Object.keys(this.currentProstyn).length ){
        let offerProstyn = {}
        if( typeof this.currentMaterialProstyn.name !== "undefined" && this.currentMaterialProstyn.name !== "" ){
          offerProstyn = this.currentProstyn.OFFERS.find(offer => {
                return offer.PROPERTIES.GABARITY.VALUE === this.currentSizeProstyn.name &&
                    offer.PROPERTIES.MATERIAL_TYPE.VALUE === this.currentMaterialProstyn.name
              }
          );
        }else{
          offerProstyn = this.currentProstyn.OFFERS.find(offer => offer.PROPERTIES.GABARITY.VALUE === this.currentSizeProstyn.name );
        }
        if( typeof offerProstyn === "undefined"){
          console.log("offerProstyn не найдено размеров", offerProstyn);
        }
        this.offerProstyn=offerProstyn;
        price = price+( Number(offerProstyn.MIN_PRICE.DISCOUNT_VALUE) * this.countProstyn );
      }
      if( typeof this.currentNavolchki != "undefined" && Object.keys(this.currentNavolchki).length ){
        let offerNavolchki = {}
        if( typeof this.currentMaterialNavolchki.name !== "undefined" && this.currentMaterialNavolchki.name !== "" ){
          offerNavolchki = this.currentNavolchki.OFFERS.find(offer => {
                return offer.PROPERTIES.GABARITY.VALUE === this.currentSizeNavolchki.name &&
                    offer.PROPERTIES.MATERIAL_TYPE.VALUE === this.currentMaterialNavolchki.name
              }
          );
        }else{
          offerNavolchki = this.currentNavolchki.OFFERS.find(offer => offer.PROPERTIES.GABARITY.VALUE === this.currentSizeNavolchki.name );
        }
        if( typeof offerNavolchki === "undefined"){
          console.log("offerNavolchki не найдено размеров", offerNavolchki);
        }
        this.offerNavolchki=offerNavolchki;
        price = price+( Number(offerNavolchki.MIN_PRICE.DISCOUNT_VALUE) * this.countNavolchki );
      }
      if( typeof this.currentValiki != "undefined" && Object.keys(this.currentValiki).length ){
        let offerValiki = {}
        if( typeof this.currentMaterialValiki.name !== "undefined" && this.currentMaterialValiki.name !== "" ){
          offerValiki = this.currentValiki.OFFERS.find(offer => {
                return offer.PROPERTIES.GABARITY.VALUE === this.currentSizeValiki.name &&
                    offer.PROPERTIES.MATERIAL_TYPE.VALUE === this.currentMaterialValiki.name
              }
          );
        }else{
          offerValiki = this.currentValiki.OFFERS.find(offer => offer.PROPERTIES.GABARITY.VALUE === this.currentSizeValiki.name );
        }
        if( typeof offerValiki === "undefined"){
          console.log("offerValiki не найдено размеров", offerValiki);
        }
        this.offerValiki=offerValiki;
        price = price+( Number(offerValiki.MIN_PRICE.DISCOUNT_VALUE) * this.countValiki );
      }
      if( typeof this.currentProstynUniversal != "undefined" && Object.keys(this.currentProstynUniversal).length ){
        let offerProstynUniversal = {}
        if( typeof this.currentMaterialProstynUniversal.name !== "undefined" && this.currentMaterialProstynUniversal.name !== "" ){
          offerProstynUniversal = this.currentProstynUniversal.OFFERS.find(offer => {
                return offer.PROPERTIES.GABARITY.VALUE === this.currentSizeProstynUniversal.name &&
                    offer.PROPERTIES.MATERIAL_TYPE.VALUE === this.currentMaterialProstynUniversal.name
              }
          );
        }else{
          offerProstynUniversal = this.currentProstynUniversal.OFFERS.find(offer => offer.PROPERTIES.GABARITY.VALUE === this.currentSizeProstynUniversal.name );
        }
        if( typeof offerProstynUniversal === "undefined"){
          console.log("offerProstynUniversal не найдено размеров", offerProstynUniversal);
        }
        this.offerProstynUniversal=offerProstynUniversal;
        price = price+( Number(offerProstynUniversal.MIN_PRICE.DISCOUNT_VALUE) * this.countProstynUniversal );
      }
      this.offerActual.MIN_PRICE.DISCOUNT_VALUE = price;
    },
    async offersProduct(){
      if( this.product.OFFERS.length === 1 && this.product.TYPE_PRODUCT!=='set') {
        const offers = (
            await this.$axios({
              url: '/ajax/offers-product.php?id=' + this.product.ID,
              method: 'post',
              params: {}
            })
        )
        if (offers) {
          this.product.OFFERS = offers.data;
          //this.offerspost=true;
        } else {
          console.log('error offers')
        }
      }
    },
    async requestSetProducts(prodjson,field,current,currentSize,arSize, currentSetMaterials, arMaterialPododeyalnika){
      await this.$axios({
        url: '/ajax/arproductsxliid.php',
        method: 'post',
        data: {
          prodjson: prodjson,
          site_id: this.$store.state.siteid,
          template_site: this.$store.state.langs.TEMPLATE_SITE,
          findoffer: 'one'
        }
      }).then(response => {
        if (response.status == 200) {
          let dataProduct = response.data;
          this[field] = dataProduct;
          this[current] = dataProduct[0];
          let offerSelected = dataProduct[0].OFFERS[0];
          //offerSelected = dataProduct[0].OFFERS.find(offer => offer.ID === dataProduct[0].OFFER_ID_SELECTED);
          if( offerSelected.PROPERTIES.GABARITY && offerSelected.PROPERTIES.GABARITY.VALUE ) {
            this[currentSize].name = offerSelected.PROPERTIES.GABARITY.VALUE;
            this[currentSize].iblock_id = dataProduct[0].IBLOCK_ID;
            this[currentSize].id = offerSelected.ID;
            this[arSize].push(offerSelected.PROPERTIES.GABARITY.VALUE);
          }
          if( offerSelected.PROPERTIES.MATERIAL_TYPE && offerSelected.PROPERTIES.MATERIAL_TYPE.VALUE ) {
            this[arMaterialPododeyalnika].push(offerSelected.PROPERTIES.MATERIAL_TYPE.VALUE);
            this[currentSetMaterials].name=offerSelected.PROPERTIES.MATERIAL_TYPE.VALUE;
          }

          this.updateSetPrice();
          //this.loadingDop=false;
        } else {
          console.log("request requestSetProducts error")
        }
      }).catch(e => {
        console.log('Error: ' + e);
      })
    },
    async requestSetProductOffersOne(id, currentName, arSizeName, arMaterialName, loadSize){
      await this.$axios({
        url: '/ajax/offers-product.php?id=' + id,
        method: 'post',
        data: {}
      }).then(response => {
        if (response.status == 200) {
          ///let index = inputArr.findIndex(el => el.name === searchName);
          let dataProduct = response.data
          this[currentName].OFFERS = dataProduct;
          let size = [];
          let sizeMaterial = [];
          dataProduct.forEach((offer, index) => {
            if( offer.PROPERTIES.GABARITY && offer.PROPERTIES.GABARITY.VALUE ) {
              size.push(offer.PROPERTIES.GABARITY.VALUE);
            }

            if( offer.PROPERTIES.MATERIAL_TYPE && offer.PROPERTIES.MATERIAL_TYPE.VALUE ) {
              sizeMaterial.push(offer.PROPERTIES.MATERIAL_TYPE.VALUE);
            }

          });
          this[arSizeName]=[...new Set(size)];
          this[arMaterialName]=[...new Set(sizeMaterial)];
          this[loadSize]=false;
        } else {
          console.log("request requestSetProductsOne error")
        }
      }).catch(e => {
        console.log('Error: ' + e);
      })
    },
    dateDelivery(){
      let resDate = "На заказ";
      let date = new Date();
      if(this.product.STORE){
        resDate = "Завтра";
      }else if( this.product.PROPERTIES.SROK_DOSTAVKI && this.product.PROPERTIES.SROK_DOSTAVKI.VALUE ) {
        let propDate = this.product.PROPERTIES.SROK_DOSTAVKI.VALUE;
        if(propDate==="1 день" || propDate==="В наличии"){
          //date.setDate(date.getDate() + 1);
          resDate = "Завтра";
        }else if(propDate==="7 дней"){
          date.setDate(date.getDate() + 7);
          resDate = date.toLocaleString('ru', {year: 'numeric',month: 'long',day: 'numeric'});
        }else if(propDate==="2 недели"){
          date.setDate(date.getDate() + 14);
          resDate = date.toLocaleString('ru', {year: 'numeric',month: 'long',day: 'numeric'});
        }else if(propDate==="3 недели"){
          date.setDate(date.getDate() + 21);
          resDate = date.toLocaleString('ru', {year: 'numeric',month: 'long',day: 'numeric'});
        }
      }
      return resDate;
    },
    deliveryPopup(){
      if (typeof (ym) === "function") {
        ym(this.$store.state.langs.YACOUNTER, 'reachGoal', 'delivery_block_view');
      }
      this.$bus.$emit('openedPopup','delivery');
    },
    locationPickup(){
      this.$bus.$emit('openedPopup','pickup');
      //location.href="#pickup";
    },
    openBoxberry() {
     // boxberry.open('callback_function', '', this.$store.state.currentCity)
      this.$bus.$emit('openedPopupMapPvz', this.$store.state.currentCity);
      return false
    },
    checkBoxberry(){
      if(!this.iblockid) return false;
      let iblocksIdpickpoint = this.$store.state.langs.IBLOCKS_ID_PICKPOINT;
      if(iblocksIdpickpoint.includes(this.iblockid)){
        return true;
      }
      return false;
    },
    imagesView() {
      setTimeout(() => {
        const allImagesWithDataSrc = document.querySelectorAll('img[data-src]')
        allImagesWithDataSrc.forEach(image => {
          image.setAttribute('src', image.getAttribute('data-src'))
        })
      }, 1000)
    },
    setShowRoomSign(){
      this.showRoomSign=true;
    },
    setTestDriveHome(){
      this.testDriveHome=true;
    },
    errorBorder(){
      const phoneError = document.querySelector('input[type="tel"]');
      if(phoneError) {
        phoneError.classList.remove('error');
      }
    }
  },
  mounted() {
   // this.isMobile = document.body.clientWidth < 768
   // const protocol = location.protocol;
   // const url = (protocol == "http") ? 'http://points.boxberry.ru/js/boxberry.js' : 'https://points.boxberry.de/js/boxberry.js'
   // let boxberryScript = document.createElement('script')
   // boxberryScript.setAttribute('src', url)
   // document.head.appendChild(boxberryScript)
  },
}
</script>

<style lang="scss" scoped>
  .size-increase{
    display: flex;
    gap: 30px;
    align-items: center;
    max-width: 470px;
    justify-content: space-around;
  }

  .size-increase__item{
    max-width: 70px;
    text-align: center;
  }
</style>
